/**
 * Created by renjie.huang on 2017/12/5.
 */

var route = {
    path : '/register',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/Home.jsx').default)
        }, 'home')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/register-old.js